import React from 'react';
import { isMobileNativeApp } from './../../../utils/mobileAppCheck';
import './common.scss';

const IDVInfoButton=()=>{
  return (
    <div className="tooltip-container" tabIndex={0} role="tooltip" aria-labelledby="IDVText">
      <span className="input-label-info-icon standard-blue">&#9432;</span>
      <div className={`idv-tooltip ${isMobileNativeApp()?'idv-mobile-tool-tip':''}`}>
        <div className={`idv-tooltip__arrow ${isMobileNativeApp()?'idv-mobile-arrow':''}`}></div>
        <div className="tooltip-block"></div>
        <span id="IDVText">On the back of your card.</span>
      </div>
    </div>
  );
};

export default IDVInfoButton;
